export const DEPOSIT = 50000;

export const 같이취득2명할인금액 = 10000;
// export const 같이취득3명할인금액 = 20000;
